export enum ReindeerLocationType {
    Country = 0,
    Reinbeiteomrade = 1,
    Reinbeitedistrikt = 2
}
